(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game-container.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game-container.js');

'use strict';

const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _svs$components$marke = svs.components.marketplace.gameList,
  Game = _svs$components$marke.Game,
  GameStatus = _svs$components$marke.GameStatus;
const getGameAriaLabel = svs.components.marketplace.helpers.games.getGameAriaLabel;
const _svs$components$marke2 = svs.components.marketplaceData.gamesConstants,
  GAME_BUYIN_CLOSED = _svs$components$marke2.GAME_BUYIN_CLOSED,
  GAME_STATUS_SOLD_OUT = _svs$components$marke2.GAME_STATUS_SOLD_OUT,
  GAME_STATUS_REFUNDED = _svs$components$marke2.GAME_STATUS_REFUNDED,
  GAME_STATUS_DRAW_CLOSED = _svs$components$marke2.GAME_STATUS_DRAW_CLOSED,
  GAME_STATUS_SUBMITTABLE = _svs$components$marke2.GAME_STATUS_SUBMITTABLE;
const FractionPayment = svs.components.marketplace.fractionPayment.FractionPayment;
const showDialog = svs.components.marketplaceData.dialogWrapper.actions.showDialog;
const useGetGameUrl = svs.components.marketplace.gameList.hooks.useGetGameUrl;
const roles = svs.components.marketplaceData.auth.roles;
const Button = svs.ui.ReactButton;
const _svs$components$marke3 = svs.components.marketplace.helpers,
  getTeamUrl = _svs$components$marke3.getTeamUrl,
  getRetailUrl = _svs$components$marke3.getRetailUrl;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const GameContainer = _ref => {
  var _ref4;
  let game = _ref.game,
    gameIndex = _ref.gameIndex,
    fromTeamList = _ref.fromTeamList,
    gameLinkSearch = _ref.gameLinkSearch,
    groupId = _ref.groupId,
    groupName = _ref.groupName,
    hasBottomBorder = _ref.hasBottomBorder,
    hasNoFractionPayment = _ref.hasNoFractionPayment,
    isListing = _ref.isListing,
    isRetail = _ref.isRetail,
    location = _ref.location,
    offsetForLastClicked = _ref.offsetForLastClicked,
    role = _ref.role;
  const activatedDrawId = game.activatedDrawId,
    buyStop = game.buyStop,
    containerId = game.containerId,
    fractions = game.fractions,
    gameStatus = game.status,
    isSoldOut = game.isSoldOut,
    isSubmitted = game.isSubmitted,
    productFamily = game.productFamily,
    productName = game.productName;
  const myId = useSelector(_ref2 => {
    let customerId = _ref2.customerId;
    return customerId;
  });
  const isCurrentUserAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const fractionsCount = fractions && fractions[myId] || 0;
  const gameUrl = useGetGameUrl(game);
  const isBeforeBuyStop = buyStop && buyStop.getTime() - Date.now() > 0;
  const dispatch = useDispatch();
  let queryString = '';
  if (gameLinkSearch) {
    queryString = "?".concat(gameLinkSearch);
  } else if (location.search) {
    queryString = "?".concat(location.search);
  }
  const handlePostGameClick = e => {
    e.preventDefault();
    const diffBuyStop = new Date(buyStop).getTime() - Date.now();
    const shouldShowSubmitWarning = !isSoldOut && diffBuyStop >= 0;
    const navigateToGame = () => location.assign(gameUrl);
    if (shouldShowSubmitWarning) {
      dispatch(showDialog({
        title: 'Vill du lämna in spelet i förtid?',
        text: "\"Sista andelsk\xF6p\" har inte passerats, s\xE5 alla medlemmar kanske inte har haft chans att l\xE4gga sin insats. ".concat(fractionsCount ? "".concat(fractionsCount, " andelar \xE4r s\xE5lda") : ''),
        icon: 'nav-my-games',
        buttons: [{
          classes: {
            inverted: true
          },
          text: 'Avbryt'
        }, {
          callback: navigateToGame,
          text: 'Gå vidare'
        }]
      }));
    } else {
      navigateToGame();
    }
  };
  const shouldDisplayPayButton = () => isBeforeBuyStop && !hasNoFractionPayment && !isSoldOut && !isSubmitted;
  const renderFractionPayment = () => {
    var _ref3;
    const isEnded = role === GAME_STATUS_REFUNDED || role === GAME_STATUS_DRAW_CLOSED;
    const isCaptainOrAdmin = (_ref3 = role !== '') !== null && _ref3 !== void 0 ? _ref3 : roles.hasPermission(role, roles.PERMISSIONS.PREPARE_GAME);
    const gameIsSubmittable = gameStatus === GAME_BUYIN_CLOSED || gameStatus === GAME_STATUS_SOLD_OUT || gameStatus === GAME_STATUS_SUBMITTABLE;
    if (isEnded || !groupId || !shouldDisplayPayButton()) {
      return null;
    }
    if (gameIsSubmittable && isCaptainOrAdmin) {
      return React.createElement("div", {
        className: "game-payment"
      }, React.createElement(Button, {
        className: "btn btn-100 btn-block btn-transparent-default qa-post-game-button",
        onClick: handlePostGameClick
      }, "L\xE4mna in spelet"));
    }
    return React.createElement(FractionPayment, {
      activatedDrawId: activatedDrawId,
      className: "game-payment",
      containerId: containerId,
      game: game,
      groupId: groupId,
      hasSnackbar: false,
      isBrowseGames: true,
      isSmall: true
    });
  };
  const linkTo = isRetail ? getRetailUrl(groupId, groupName, 'spel', containerId, activatedDrawId) : getTeamUrl(groupId, groupName, 'spel', containerId, activatedDrawId);
  const product = (_ref4 = productFamily || productName) === null || _ref4 === void 0 ? void 0 : _ref4.toLowerCase();

  const LinkComponent = _ref5 => {
    let children = _ref5.children;
    const classes = ['game-link', 'qa-navigate-game'];
    const toProps = fromTeamList ? "".concat(linkTo).concat(queryString) : {
      pathname: linkTo,
      query: gameLinkSearch || location.search,
      state: {
        internalLink: true,
        hasBackButton: true
      }
    };
    return React.createElement(Link, {
      "aria-label": getGameAriaLabel({
        game,
        groupId,
        isCurrentUserAuthenticated,
        isListing,
        isRetail
      }),
      className: classes.filter(Boolean).join(' '),
      key: "game_".concat(gameIndex),
      onClick: () => {
        svs.components.Storage.browser.set('lastClickedGame', 'marketplace', {
          activatedDrawId,
          offset: offsetForLastClicked
        });
      },
      rel: "nofollow",
      to: toProps
    }, children);
  };
  return React.createElement(React.Fragment, {
    key: activatedDrawId
  }, Boolean(game && activatedDrawId) && React.createElement("section", {
    className: hasBottomBorder ? 'game-link-bottom-border' : '',
    "data-testid": "qa-game-container"
  }, React.createElement(Game, {
    game: game,
    groupId: groupId,
    isListing: isListing,
    isRetail: isRetail,
    LinkComponent: LinkComponent,
    productName: product,
    shouldScrollTo: true
  }, React.createElement(GameStatus, {
    game: game,
    gameStatus: gameStatus,
    groupId: groupId,
    isListing: isListing,
    isRetail: isRetail
  })), renderFractionPayment()));
};
GameContainer.defaultProps = {
  gameLinkSearch: '',
  hasBottomBorder: false,
  role: ''
};
setGlobal('svs.components.marketplace.gameList.GameContainer', GameContainer);

 })(window);